/* eslint-disable */
/** 
 * This file contains language specific message functions for tree-shaking. 
 * 
 *! WARNING: Only import messages from this file if you want to manually
 *! optimize your bundle. Else, import from the `messages.js` file. 
 * 
 * Your bundler will (in the future) automatically replace the index function 
 * with a language specific message function in the build step. 
 */


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const meta_title = () => `Amverum`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_apply = () => `Apply`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_cancel = () => `Cancel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_delete = () => `Delete`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_add = () => `Add`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_save = () => `Save`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_download = () => `Download`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_send = () => `Send`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_close = () => `Close`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_change = () => `Change`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_build = () => `Build`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_save_and_rerun = () => `Save and rerun`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const select_default = () => `Not selected`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const datepicker_pick_date = () => `Pick a date`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const datepicker_pick_date_range = () => `Pick a date range`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const datepicker_min = () => `Minutes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const datepicker_hours = () => `Hours`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const form_date_picker_from = () => `From`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const form_date_picker_to = () => `To`


/**
 * @param {{ N: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const form_date_picker_last_N_minutes = (params) => `Last ${params.N} minutes`


/**
 * @param {{ N: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const form_date_picker_last_N_hours = (params) => `Last ${params.N} hour(s)`


/**
 * @param {{ N: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const form_date_picker_last_N_hours_plural = (params) => `Last ${params.N} hour(s)`


/**
 * @param {{ N: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const form_date_picker_last_N_hours_plural_2 = (params) => `Last ${params.N} hour(s)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const field_name = () => `Name`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const required_field = () => `Required field`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const no_spaces = () => `No spaces`


/**
 * @param {{ maxLength: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const max_length = (params) => `Max length is ${params.maxLength} characters`


/**
 * @param {{ minLength: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const min_length = (params) => `Min length is ${params.minLength} characters`


/**
 * @param {{ maxNumber: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const max_number = (params) => `Max amount is ${params.maxNumber}`


/**
 * @param {{ minNumber: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const min_number = (params) => `Min amount is ${params.minNumber}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const data_table_pagination_rpp = () => `Rows per page`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const data_table_pagination_page = () => `Page`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const data_table_noResults = () => `No results.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const header_user_exit = () => `Exit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const header_balance = () => `Balance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const header_lang = () => `Language:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const api_error_somethingWentWrong = () => `Something went wrong`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const api_success = () => `Success`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const field_error_required = () => `Required field`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const confirm_dialog_title = () => `Confirm`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const confirm_dialog_yes = () => `Yes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const confirm_dialog_no = () => `No`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_null = () => `Project didn't deploy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_null_hint = () => `To launch the application, upload the data and build the project`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_CREATING = () => `Creating project`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_CREATING_hint = () => `If the project remains in the creating status for more than a minute, an error has occurred. Please recreate the project`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_EMPTY = () => `Project didn't deploy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_EMPTY_hint = () => `To launch the application, upload the data and build the project`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_BUILD_STARTED = () => `Building project`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_BUILD_STARTED_hint = () => `You can track the build process in the "Build Log" tab`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_BUILD_STOPPED = () => `Build stopped`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_BUILD_FAILED = () => `Build error. Check build logs`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_BUILD_FAILED_hint = () => `Check the "Build Log" tab for errors. Verify the correctness of the configuration and/or Dockerfile`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_DEPLOYING = () => `Deploying the project`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_DEPLOYING_hint = () => `The build was successful, deployment is in progress`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_DEPLOY_FAILED = () => `Deployment error. Check run logs`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_DEPLOY_FAILED_hint = () => `Deployment failed. Check the correctness of amvera.yaml/Dockerfile. If the error persists, contact support`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STARTING = () => `Starting the project`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STARTING_hint = () => `Successfully deployed, starting the application`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_RUN_ERROR = () => `The application is starting or running with errors. Check run logs`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_RUN_PROBLEM = () => `Running with errors. Check the run log`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_RUN_PROBLEM_hint = () => `Application containers cannot start due to an error.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_RUN_ERROR_hint = () => `The application has not yet started or has encountered an error. Check the application log and configuration file`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_RUNNING = () => `Running`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_RUNNING_hint = () => `The application is running without errors`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STOPPED = () => `Stopped`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STOPPED_hint = () => `To resume, use the start button or set the desired number of instances`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STOPPING = () => `The service is stopping`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_FROZEN = () => `Project is frozen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_FROZEN_hint = () => `The project was stopped more than 30 days ago. To start, rebuild and launch the project`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STOPPED_WITH_ERROR = () => `Stopped due to recurring error. Check build/run logs`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STOPPED_WITH_ERROR_hint = () => `Stopped due to a recurring error. Check the application log to determine the cause`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_SCALING = () => `Changing the number of replicas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_SCALING_hint = () => `Changing the number of replicas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_clusterHealthyState = () => `PostgreSQL is running`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_settingUpPrimary = () => `PostgreSQL is starting`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_waitingForInstances = () => `PostgreSQL is starting`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_creatingNewReplica = () => `Creating a new replica`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_title = () => `Upload files`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_commitMsg = () => `Commit message`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_commitMsg_placeholder = () => `Enter the commit message`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_text = () => `To upload, drag folders or files to this area`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_maxSize = () => `Maximum size:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_mb = () => `MB`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_zip = () => `Uploading Zip archives is not supported`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_uploadedFiles = () => `Uploaded files`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_noFiles = () => `No files uploaded`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_deleteAll = () => `Delete all`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_success = () => `File upload was successful.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const projectCreation_firstProject = () => `Create your first project!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const projectCreation_firstDb = () => `Create a database`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const projectCreation_firstProject_title = () => `No projects yet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const projectCreation_firstProject_free = () => `Project creation is free.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const projectCreation_firstProject_free_desc = () => `Charges are only applied for working containers in the statuses "Application Started" or "Application Running with Errors."`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_sidebar_title = () => `Projects`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_sidebar_apps = () => `Applications`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_sidebar_postgres = () => `PostgreSQL`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_sidebar_preconfigured = () => `Preconfigured services`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_sidebar_docs = () => `Amverum documentation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_info = () => `Info`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_repo = () => `Repository`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_dir = () => `Directory`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_config = () => `Configuration`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_logs = () => `Logs`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_envvars = () => `Variables`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_domains = () => `Domains`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_backups = () => `Backups`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_alerts = () => `Monitoring`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_settings = () => `Settings`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_logDb = () => `Database logs`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_details = () => `Details`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_balance = () => `Manage balance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_legal = () => `For legal entities`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_main = () => `Home`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_projects = () => `Projects`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_applications = () => `Applications`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_dbs = () => `PostgreSQL`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_balance = () => `Balance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_preConfig = () => `Preconfigured services`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_title = () => `Create project`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service = () => `Service selection`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff = () => `Pricing plan`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload = () => `Data upload`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_config = () => `Configuration`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_variables = () => `Variables`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_next_btn = () => `Next`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_back_btn = () => `Back`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_fin_btn = () => `Finish`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_gitDialog_desc = () => `Before completing the creation, you can set and download the configuration file. After that, place it in the root of the project, run the git push command, and the build will start automatically.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_gitDialog_confirm = () => `Complete creation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_serviceType = () => `Service type`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_serviceType_placeholder = () => `Select a service type`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_projectType = () => `Set service parameters`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_projectType_placeholder = () => `Select a project type`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketType = () => `Set service type`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketType_placeholder = () => `Select service type`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_serviceTypes_app = () => `Application`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_serviceTypes_db = () => `Database (managed)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_serviceTypes_marketplace = () => `Pre-configured application from the marketplace`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_mq = () => `Message brokers`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_db = () => `Databases`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_authorization = () => `Authorization`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_bi = () => `Business Intelligence`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_db_utils = () => `Database utilities`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_db_mail_and_notifications = () => `Mail and notifications`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_ai = () => `Machine Learning and Artificial Intelligence`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_projectName = () => `Project name`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_projectName_placeholder = () => `Enter a project name`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_projectName_symbolErrors = () => `The project name may contain lowercase and uppercase letters, numbers, and hyphens.`


/**
 * @param {{ maxLength: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_projectName_lengthError = (params) => `Maximum length is ${params.maxLength} characters.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_projectName_noNew = () => `The word "new" cannot be used.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_plan_alert = () => `We recommend using one of the higher-tier plans for the first launch. After a successful launch, you can lower the plan.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_plan = () => `Select pricing plan`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload_gitOption = () => `Via git`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload_gitOption_hint = () => `You can skip the steps by creating an empty project and uploading files and configuration later.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload_interfaceOption = () => `Via interface`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload_interfaceOption_hint_start = () => `If the project is in Python, don't forget the requirements.txt file `


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload_interfaceOption_hint_link = () => `(instructions for creation)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload_interfaceOption_hint_end = () => ` and do not upload the venv folder.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_config_alert = () => `Setting the configuration creates a commit in the repository. To link to existing repositories, a merge will be required.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_config_title = () => `Configuration file`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_config_downloadConfig = () => `Download configuration`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_error_409 = () => `Project with this name already exists`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_error_500 = () => `Server error`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_title = () => `Projects`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_card_app = () => `Applications`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_card_db = () => `PostgreSQL`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_card_preconfigured = () => `Preconfigured services`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_card_total = () => `Total`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_card_running = () => `Running`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_card_clutster = () => `Cluster`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_createBtn = () => `Create project`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_services = () => `Create a preconfigured service`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const db_main_page_title = () => `PostgreSQL Database`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const db_main_page_table_column_name = () => `Name`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const db_main_page_table_column_type = () => `Type`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const db_main_page_table_filter = () => `Database type`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_main_page_btn = () => `Create an application`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const preConfig_main_page_title = () => `Preconfigured services`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const preConfig_main_page_btn = () => `Create a preconfigured service`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const resource_status_NONE = () => `Inactive`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const resource_status_NO_DATA = () => `Calculating consumption`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const resource_status_RED = () => `Consumption Above 85%`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const resource_status_YELLOW = () => `High Consumption`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const resource_status_GREEN = () => `Consumption is normal`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_replicas = () => `Replicas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_replicas_tooltip_cur = () => `Current number of instances`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_replicas_tooltip_req = () => `Required number of instances`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_start = () => `Turn on`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_stop = () => `Turn off`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_rebuild = () => `Rebuild`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_rerun = () => `Rerun`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_project = () => `project`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_title = () => `Add funds`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_topup = () => `Top-up amount`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_limit = () => `Limitation of auto payments per month`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_limit_tooltip = () => `Autopayment is made only when the balance decreases to <1$. Set the maximum number of autopayments per month`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_autoPay = () => `Connect auto payment`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_addFunds = () => `Add funds`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_promoCode = () => `Promo code`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_usedPromocodes = () => `Used promo codes:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_promoCode_placeholder = () => `Enter promo code`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_promo_200 = () => `Promo code successfully added`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_promo_404 = () => `Invalid promo code`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_promo_406 = () => `The promo code has expired`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_promo_409 = () => `Promo code already used`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_promo_500 = () => `Server error, try again later`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_promo_501 = () => `The promo code has not been implemented yet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_recurrent_delete_success_snack = () => `Auto payment removed.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_recurrent_amount = () => `Connected auto payment amount:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_recurrent_max_amount = () => `Maximum number of payments per month:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_details_req = () => `Details and requisites`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs = () => `Closing documents`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice = () => `Create an invoice`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_shortName = () => `Short name of the legal entity *`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_fullName = () => `Full name of the legal entity`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_tin = () => `TIN *`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_kpp = () => `KPP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_ogrn = () => `OGRN`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_beneficiaryAccount = () => `Account`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_bic = () => `Bank BIC`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_additionalMail = () => `Additional contact email`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_additionalMail_emailError = () => `Enter a valid email`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_additionalPhoneNumber = () => `Additional contact phone number`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_additionalPhoneNumber_numberError = () => `Enter a valid phone number`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_amount_error = () => `Enter a valid amount`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs_docType = () => `Document type`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs_docType_BILL = () => `Bill`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs_docType_INVOICE = () => `Invoice`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs_docType_RECONCILIATION_REPORT = () => `Reconciliation report`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs_date = () => `Creation date`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs_time = () => `Period`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_warn = () => `The transfer may take 3 to 5 business days`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_btn_issue = () => `Issue an invoice`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_table_date = () => `Invoice date`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_table_status = () => `Status`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_table_amount = () => `Amount due`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_table_sendEmail = () => `Send by email`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_sendEmail_200 = () => `Email sent!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_emailTitle = () => `Send by email`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_emailInfo = () => `The invoice will be sent to the email address provided during registration:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_orDiffEmail = () => `Or enter a different email:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_history = () => `Payment History`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_writeOffs = () => `Write-offs`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_credits = () => `Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_serviceType = () => `Service Type`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_service = () => `Service`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_plan = () => `Plan`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_productName = () => `Resource type`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_units = () => `Number of Units`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_price = () => `Price per Unit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_amount = () => `Amount`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_from = () => `Paid at`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_to = () => `Paid to`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_amount2 = () => `Amount`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_paymentType = () => `Payment type`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_currency = () => `Currency`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_date = () => `Date`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_manual = () => `Manual payment`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_autoPayment = () => `Auto payment`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_examplesHelper = () => `Deployment examples`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_herokuHelper = () => `Migration from Heroku`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_configHeader = () => `Configuration file`


/**
 * @param {{ docDomain: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_configDescription = (params) => `To run the project, you need the <a target='_blank' rel='noopener noreferrer' className='text-link underline' href='${params.docDomain}/applications/configuration/config-file.html'>amvera.yml</a> configuration file, which can be written manually, generated via a special service or specified in the Configuration tab. <a target='_blank' rel='noopener noreferrer' className='text-link underline' href='${params.docDomain}/applications/configuration/docker.html'>Dockerfile</a> is also supported.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_deployHeader = () => `Deploying the project`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_deployDescription = () => `The project uses a Git repository to store the code, the contents and access data for which are available in the "Repository" section.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_deployOptionsHeader = () => `Three main ways to deploy a project`


/**
 * @param {{ docDomain: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_deployOptionsLi1 = (params) => `Through push to a Git repository with a configuration file. You need to clone or link the project repository, add the <a target='_blank' rel='noopener noreferrer' className='text-link underline' href='${params.docDomain}/applications/configuration/config-file.html'>configuration file</a> to its root and do a git push. The project will start building automatically.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_deploymentOptionsLi2 = () => `Through push to a Git repository and configuration in the interface. In the "Configuration" section, specify the necessary parameters and click "Apply", clone a repository for yourself, which will now contain a configuration file, transfer the necessary code to this repository and do a push. The project will start building automatically.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_deploymentOptionsLi3 = () => `Use the loader on the "Repository" page. When all data is loaded, fill in the Configuration section (if you have not loaded the configuration file) and click the "Apply" and "Collect" buttons.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_domainHeader = () => `Domains and internal names`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_domainDescription = () => `You can connect a free one or bind your own domain name in the "Domains" tab`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_domainOptionsLi1 = () => `Internal domain name:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_domainOptionsLi1_caption = () => `can be accessed from another project, must listen on port 80`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_domainOptionsLi2 = () => `Persistent storage folder:`


/**
 * @param {{ serviceType: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_marketplace_title = (params) => `${params.serviceType} — pre-configured service from the marketplace`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_marketplace_description = () => `Represents an application with specified settings and variables.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_marketplace_externalDomain = () => `You can create an external domain in the "Domains" tab.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbInfo_connectHelper = () => `Connecting to Database`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbInfo_pgAdmin = () => `Deploy pgAdmin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbInfo_domainTitle = () => `To access the database from any your Amverum projects, all you need to do is add one of these three domain names:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbInfo_domainRwOption = () => `read/write`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbInfo_domainRoOption = () => `read only in hot standby mode`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbInfo_domainROption = () => `read from any of the deployed nodes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_version_hint = () => `Postgres version`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbName = () => `Database name`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbName_placeholder = () => `Enter the DB name`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbName_hint = () => `The name for the database that will be created in the cluster.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbUsername = () => `Username`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbUsername_placeholder = () => `Enter username`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbUsername_hint = () => `The name for the user who will log into the DBMS.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbPassword = () => `User password`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbPassword_placeholder = () => `Enter the user password`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbPassword_hint = () => `The password for the user mentioned above, which will be used to log into the DBMS.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_instances = () => `DBMS cluster size`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_instances_placeholder = () => `Enter the number of replicas for the DBMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_instances_hint = () => `The number of DBMS replicas. One of the replicas will be the master, and due to DBMS specifics, write access will only be available through it.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_superuser = () => `Activate Superuser Access`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_superuser_hint = () => `Activate superuser access with the username`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_superuserPassword = () => `Superuser password`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_superuserPassword_placeholder = () => `Enter the superuser password`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_superuserPassword_hint = () => `The password for the user <code>postgres</code>, which allows logging into the DBMS with superuser privileges.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_alert_backups = () => `Backups`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_alert_restoreBackups = () => `Restore backups`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_activateDaily = () => `Activate daily backups`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_instant = () => `Instant backups`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_empty = () => `There are no backups at the moment.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_create = () => `Create backup`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_dialog_tilte = () => `Enter the description of the backup:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_dialog_create_success = () => `Backup created successfully`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_dialog_restore_errorName = () => `Name must contain only letters, numbers, spaces and dashes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_dialog_restore_maxLengthErorr = () => `Maximum length of the description is 300 characters`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_upload_btn = () => `Upload data`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_download_btn = () => `Download data`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_download_selection = () => `Select what you want to download:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_download_storage = () => `Persistent Storage`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_download_code = () => `Code`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_download_artifacts = () => `Artifacts`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_download_repo = () => `Repository`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_folder = () => `Choose folder:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_folder_empty = () => `Empty folder`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_folder_init = () => `File upload is only possible after the first launch of the application.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitTitle_v2 = () => `Connect GitHub, GitLab, Bitbucket`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitTitle = () => `Connect GitHub, GitLab, Bitbucket (manual setup)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_event = () => `Event:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_event_hint = () => `You need to select one of the options`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_url_hint = () => `Link that you need to insert in the settings of the webhook.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_secret = () => `Secret:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_secret_error = () => `Required field. It is used for validation of the request.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_token = () => `Token:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_remoteRepo = () => `Remote repository:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_remoteBranch = () => `Remote repository branch:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_remoteBranch_hint = () => `Only lowercase, uppercase latin letters, numbers and special characters can be used: <code>_</code>, <code>-</code>, <code>/</code> and <code>.</code>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connect_btn = () => `Connect`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connect_first_success = () => `Repository connected.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connect_change_success = () => `Repository changed.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connect_copied = () => `Copied to clipboard.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connection_title = () => `Or use a dedicated Amverum repository.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connection_primary = () => `Use as primary repository:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connection_or = () => `or`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connection_existing = () => `Connect to a existing repository:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connection_submit = () => `Submit changes:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connection_ifPrimary = () => `If used as primary repository:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_helper = () => `Ways to resolve possible errors`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_helper_data = () => `Be sure to save SQLite and similar files to the persistent storage /data. The correct path in the code is /data/file_name.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_delete_git_confirm = () => `Do you really want to delete?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_remoteRepo_placeholder = () => `Select a remote repository`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_remoteBranch_placeholder = () => `Select a branch`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_remoteBranch_error = () => `Remote branch is required`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_fetchBranch_error = () => `Failed to get the remote repository branches`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_post_success = () => `Webhook added successfully`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_edit_success = () => `Webhook updated successfully`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_delete_success = () => `Webhook deleted successfully`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_delete_error = () => `Failed to delete the webhook`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_existing_error_hint = () => `Webhook is already bound, you need to delete it before creating a new one`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_delete_file_confirmation = () => `To update files, upload the updated files over the old ones without deleting them. Delete anyway?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_delete_file_doNotAskAgain = () => `Do not ask again`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_field_environment_label = () => `Choose an environment`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_field_toolchain_label = () => `Choose a toolchain`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_field_version_label = () => `Choose version`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_field_change_success = () => `Configuration successfully changed`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_mainFileName_error_wrongName = () => `The specified file is not found in the code, change the name or check the path`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_mainFileName_error_wrongPath = () => `The path to the executable file does not match the path in the code`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_python_requirementsPath_error_noFile = () => `The requirements.txt file is not found in the uploaded files, or it has another name. Upload a file with dependencies or bring the name into correspondence with the value in the configuration`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_python_requirementsPath_error_wrongName = () => `The specified file is not found in the code, change the name or check the path. <a target='_blank' rel='noopener noreferrer' className='text-status-info link' href='https://docs.amvera.ru/applications/environments/python-pip.html#requirements-txt'>How to create</a> requirements.txt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_python_requirementsPath_error_wrongPath = () => `The path to requirements.txt in the code and configuration do not match`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_build_log = () => `Build log`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_run_log = () => `Run log`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_db_log = () => `DB log`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_system_log = () => `System log`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_alertTitle_default = () => `The log loading takes up to 3 minutes.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_alertTitle_build = () => `See the Run log (not the build) if the project status is "Application is starting" or "Running". The log loading takes up to 3 minutes.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_alertTitle_run = () => `See the Build log (not the run) if the project status is "Building project". The log loading takes up to 3 minutes.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_alert_errors = () => `Common errors`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_loading = () => `Loading log history...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_download_hint = () => `To download the log history, click the "Execute query" button or enable "Tail mode"`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_load_logs = () => `Execute query`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_query = () => `Log query`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_limit = () => `Limit entries`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_show_date = () => `Show date`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_tail_mode = () => `Tail mode`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_no_logs = () => `No logs yet, repeat the request in a minute.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_title = () => `Environment variables`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_noVars = () => `No environment variables yet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_alert_desc = () => `To apply changes, you need to restart the containers`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_secret_btn = () => `Create a secret`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_secret_title = () => `Secret creation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_secret_description = () => `Secrets are only available in containers of this project and cannot be viewed after creation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_field_value = () => `Value`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_var_btn = () => `Create a variable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_var_title = () => `Variable creation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_var_description = () => `Environment variables are only available in containers of this project`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_var_name_error_quotes = () => `Name cannot contain quotes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_var_value_error_quotes = () => `Value cannot contain quotes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_table_column_name = () => `Name`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_table_column_value = () => `Value`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_table_column_secret = () => `Is it secret`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_table_actions = () => `Actions`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_table_action_changeVar = () => `Edit variable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_changeVar_title = () => `Variable editing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_changeVar_desc = () => `Environment variables are only available in containers of this project`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_changeSec_title = () => `Secret editing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_changeSec_desc = () => `Secrets are only available in containers of this project and cannot be viewed after creation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_table_action_deleteVar = () => `Delete variable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_delete_title = () => `Variable deletion`


/**
 * @param {{ name: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_delete_desc = (params) => `Are you sure you want to delete the variable ${params.name}?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_page_title_im = () => `Domain names`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_column_action = () => `Action`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_column_connectionType = () => `Connection type`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_column_type = () => `Type`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_column_type_internal = () => `Internal`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_column_type_external = () => `External`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_domainType_external = () => `External domain`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_domainType_internal = () => `Internal domain`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_editDialog_title = () => `Default domain name`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_editDialog_desc_deactivate = () => `Deactivate the default domain name?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_editDialog_desc_activate = () => `Activate the default domain name?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_deleteDialog_title = () => `Delete`


/**
 * @param {{ domainName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_deleteDialog_desc = (params) => `Delete domain '${params.domainName}'?`


/**
 * @param {{ ingressType: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_editIngressType_success = (params) => `Connection type changed to ${params.ingressType}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_editIngressType_title = () => `Change connection type`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_editIngressType_desc = () => `You can change the connection type for this domain from HTTP to HTTPS and vice versa.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_add_btn = () => `Add a domain name`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_title = () => `Adding a domain name`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_connectionType = () => `Connection type`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_domainType = () => `Domain type`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_your = () => `Your domain`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_free = () => `Free Amverum domain`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_steps_title = () => `To add a domain you need to:`


/**
 * @param {{ externalIp: NonNullable<unknown>, ownerName: NonNullable<unknown>, slug: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_steps_1 = (params) => `Create a DNS A record: ${params.externalIp} and a TXT record: ${params.ownerName}-${params.slug}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_steps_2 = () => `Wait until the updates are distributed across DNS servers`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_steps_3 = () => `Enter the domain name in the field below (without http or https)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_name = () => `Domain name`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_placeholder = () => `Please select a connection type.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_name_placeholder = () => `Domain name without http and https`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_title = () => `Additional settings`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_section_ports = () => `Ports`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_field_url_placeholder = () => `Enter URL path`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_field_url_error = () => `URL path must start with /.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_field_url_req = () => `Enter URL path.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_field_port_placeholder = () => `Enter port`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_field_port_req = () => `Enter port.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_field_port_numberError = () => `Port must be a number.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_success = () => `Domain added successfully`


export { tab_domains_ports_success } from "./ru.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_title = () => `Backups /data`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_helper = () => `Backup`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_noAccess = () => `Backups are available for projects with the "Starter Plus" plan and above.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_noBackups = () => `Currently no backups available.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_ready_hint_EMPTY = () => `Not found. Backups are only available for persistent storage /data. Make sure you are using persistent storage and try to prepare a backup later.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_ready_hint_READY = () => `Prepare again`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_ready_hint_ERROR = () => `Error. Try to prepare again`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_ready_default = () => `Prepare for download`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_download = () => `Download backup`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_recovery_title = () => `Recovering data after the March 21 incident`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_recovery_alert = () => `Before running data recovery, restart the project and wait for some time.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_recovery_alert_409 = () => `Please restart the project first.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_recovery_button = () => `Recover data`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_recovery_success_notification = () => `Data recovery started`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_recovery_note = () => `Running data recovery will replace persistent storage with old data.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff = () => `Plan and management`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_field_plan = () => `Plan`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_alert = () => `After changing the plan, all containers will be restarted`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_field_plan_placeholder = () => `Select a plan`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_changed_success = () => `Plan changed successfully`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_managment = () => `Management`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_freeze = () => `Freeze`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_freeze_btn = () => `Freeze project`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_freeze_success = () => `Project frozen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete = () => `Delete`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_project = () => `Delete project`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_description = () => `Actions in this section are irreversible`


/**
 * @param {{ projectName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_title = (params) => `Delete project ${params.projectName}?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_dialog_description = () => `Deleting a project will stop all running instances and <b>delete the repository with the code</b>. Once you click the "Delete" button, no one - not even us - <b>will be able to recover the data</b>. If you still want to delete the project, enter the following string in the input field:`


/**
 * @param {{ projectName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_dialog_confirmText = (params) => `delete permanently ${params.projectName}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_dialog_field_placeholder = () => `Enter the deletion phrase`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_dialog_failed = () => `An error occurred while deleting the project`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_notifactions = () => `Notifications`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_notif_autoscaling = () => `Autoscaling and notifications`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts = () => `Alerts`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_interface = () => `Notifications in the interface`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard = () => `Metrics`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_success = () => `Settings changed successfully`


/**
 * @param {{ errorMessage: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_error = (params) => `${params.errorMessage}: Something went wrong`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_noAccess = () => `Alerts are available for projects with the "Starter Plus" plan and above`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_field_projectFailures = () => `Alerts for project failures`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_field_cpuUsage = () => `If the CPU usage reaches a critical level (%) above the tariff`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_field_ramUsage = () => `If the RAM usage reaches a critical level (%) above the tariff`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_field_k8 = () => `Kubernetes support`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_field_buildFailed = () => `Error during project build`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_field_runFailed = () => `Error during project run`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_field_channel = () => `Select a notification channel`


export { tab_alerts_tab_alerts_settings_field_channel_placeholder } from "./ru.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_field_channel_email = () => `Email`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_field_channel_maxPerDay = () => `Specify the maximum number of notifications per day`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_enabled_tg_bot_link = () => `Link`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_enabled_tg_bot_link2 = () => `to the telegram bot`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_disabled_tg_bot_link = () => `Notifications are connected to the telegram bot, you can change the account here:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_disabled_tg_bot_link2 = () => `link`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_enabled_tg_bot_link_hint = () => `Notifications will be sent to the account connected in the bot`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_enabled_tg_bot_alert = () => `It is required to connect notifications in the bot`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_enabled_tg_bot_qrAlt = () => `QR code to connect alerts via telegram bot`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_tg_alertValue = () => `Select a value for the alert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_tg_alertValue_placeholder = () => `Select a value`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_yamlConfig = () => `Config in yaml format`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_yamlConfig_placeholder = () => `Enter config in yaml format`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_exit_dialog_title = () => `Apply changes?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_exit_dialog_desc = () => `All unsaved changes will be lost`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_exit_dialog_closeWithoutSaving = () => `Close without saving`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_interface_title = () => `Notifications in the interface`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_interface_changed_success = () => `Settings changed successfully`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_metric_ram_label = () => `RAM Usage`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_metric_cpu_label = () => `CPU Usage`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_metric_cpu_throttling_label = () => `CPU Throttling`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_noAccess = () => `Metrics are available for projects with the "Starter Plus" plan and above`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_loading = () => `Loading data...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_error = () => `An error occured while loading data`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_noData = () => `No data`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_time = () => `Time`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_usage = () => `Usage`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_throttling = () => `Throttled time total`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_seconds = () => `s`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_failure_title = () => `Project Failure Notifications`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_failure_field_maxPerDay = () => `Maximum Notifications Per Day`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_failure_field_minUptime = () => `Minimum Application Uptime`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_failure_hint = () => `Set the maximum number of notifications per day and the minimum application uptime`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_error_popups_title = () => `Application Error Pop-up Notifications`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_autoscaling = () => `Autoscaling`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_autoscaling_description = () => `If resource load reaches a critical level (traffic light indicator is red), the system will initiate a rate increase to ensure stable operation.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_autoscaling_changed_success = () => `Settings changed successfully`


export { tab_rollbacks_table_hash } from "./ru.js"

export { tab_rollbacks_table_commitDate } from "./ru.js"

export { tab_rollbacks_table_statusCode } from "./ru.js"

export { tab_rollbacks_table_stored } from "./ru.js"

export { tab_rollbacks_table_stored_hint } from "./ru.js"

export { tab_rollbacks_table_protected } from "./ru.js"

export { tab_rollbacks_table_inUse } from "./ru.js"

export { tab_rollbacks_table_actions_runVersion } from "./ru.js"

export { tab_rollbacks_table_actions_rebuildVersion } from "./ru.js"

export { tab_rollbacks_table_actions_delete } from "./ru.js"

export { tab_rollbacks_table_actions_delete_confirm } from "./ru.js"

export { tab_rollbacks_table_actions_delete_archive } from "./ru.js"

export { tab_rollbacks_table_actions_delete_archive_confirm } from "./ru.js"

export { tab_rollbacks_table_actions_rollbackVersion } from "./ru.js"

export { tab_rollbacks_table_actions_rollbackVersion_confirm } from "./ru.js"

export { tab_rollbacks_table_actions_saveFromDel } from "./ru.js"

export { tab_rollbacks_table_actions_saveFromDel_confirm } from "./ru.js"

export { tab_rollbacks_table_actions_removeSaveFromDel } from "./ru.js"

export { tab_rollbacks_table_actions_removeSaveFromDel_confirm } from "./ru.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const snackbar_phrase_start = () => `The log recorded an error, the solution to which is described by the `


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const snackbar_phrase_link = () => `link`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const snackbar_phrase_end = () => ` in the documentation.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_socials_title = () => `We are in social networks`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_socials_vk = () => `VK`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_socials_telegram = () => `Telegram channel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_socials_habr = () => `Habr blogs`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_techsupport_title = () => `Technical support Amverum`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_techsupport_timezone = () => `We answer from 9:00 to 20:00 UTC +3`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_support_tgChat = () => `Community chat in telegram`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const repo_download_files_success = () => `Files downloaded successfully`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const repo_download_files_error = () => `Failed to download files`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const persistent_snackbar_BUILD = () => `Build`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const persistent_snackbar_RUN = () => `Run`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const persistent_snackbar_RELEASE = () => `Release`


/**
 * @param {{ stage: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const persistent_snackbar_msgTitle = (params) => `${params.stage} logs requires attention.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const field_description = () => `Description`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_python_scriptName_error_wrongName = () => `The specified file is not found in the code, change the name or check the path`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_python_scriptName_error_wrongPath = () => `The path to the executable file does not match the path in the code`
